module.exports = __webpack_public_path__ + "static/media/Rectangle 12891.97e4ac08.png";